  import { doc } from "firebase/firestore";
  import { db,auth } from "../../firebase";
  import { useAuthState } from "react-firebase-hooks/auth";
  import {useDocument} from "react-firebase-hooks/firestore"
  import { useParams } from "react-router-dom";
  import PostIDComponent from "../../components/PostID/PostIDComponent";
  import { formatDistanceToNow } from 'date-fns';
  import { useEffect, useState } from "react";
  import Update from "./functions/update";
  import '../../styles/scroll.css'
  import { Link } from "react-router-dom";
  import fetchUserProfilePicture from "../../functions/fetchUserProfilePicture";
  import fetchUsernameWithUID from "../../functions/fetchUsernameWithUID";
  import img from '../../assets/default-profile-picture.jpg'
  import PostOptionsPopup from "../../components/Posts/PostOptionsPopup";
  import { BsThreeDots } from "react-icons/bs";
  export default function Post(postId){
    const [user] = useAuthState(auth)
   
    const {pid} = useParams()
    const selectedPostId=  postId.postId ? postId.postId : pid;
    const ref = doc(db, 'posts', selectedPostId )
    const [value, loading, error] = useDocument(ref)

  
    const [imagep, setImg] = useState()
    const [name,setName] = useState()
    const [show, setShow] = useState(false)
 

    const toggle = () =>{
      setShow(!show)
    }
    useEffect(()=>{
      const fetch = async() => {
        try{
          const image = await fetchUserProfilePicture(value.data().uid)
          setImg(image)
          const username = await fetchUsernameWithUID(value.data().uid)
          setName(username)
        } catch(error){
          console.log(error)
        }
    
      }
      fetch()
    },[])
   
    const image = (imagep ===  "../assets/default-profile-picture.jpg" ? img : imagep)

    if (error) return <>error</> 

    return(
      <>
      
      <div className="flex justify-center  ">
        <div className="mt-20 div-class">
        
          {value && (
            <>
              {(user&& pid) &&(
                   <Update user={user} data={value.data()}/>
              )}
              <div className="flex border border-gray-600 flex-col p-8 " style={{maxheight:'80vh'}}>
            
              
              <div className="flex items-center">
                <div className="w-10">
                  <img src={image}></img>
                </div>
                <div className="flex-col">
                <div className="text-lg font-bold "><Link to={`/users/${name}`} className="mb-2 sm:mb-0"><span className="text-blue-500">@</span>{value.data().useName}</Link></div>
              <div className="mb-1 text-sm text-gray-500 ">{formatDistanceToNow(value.data().createdAt.toDate(), { addSuffix: true }).replace('about', '').trim()}</div>
                </div>
                {
                  user &&(
                    <div className="ml-auto">
                    <button onClick={toggle}><BsThreeDots /></button>
                  </div>
                  )
                }
               
            
                {show &&(
                    <PostOptionsPopup postId={selectedPostId} onClose={toggle}/>
                )}
              </div>
              
              <div className="w-full border border-gray-600 mt-5 mb-5"></div>
              <div className='scrollbar'style={{ maxHeight: '100vh', overflowY: 'auto' }}>
                    <PostIDComponent props={value.data()} />
                  </div>
              
              <div className="w-full border border-gray-600 mt-1 mb-6"></div>
              {value.data().title &&(
                <div className="bg-gray-100 w-fit px-2 rounded-lg">{value.data().title}</div>
              )}
              <div className="w-fit">
              {value.data().genres ? (
              Array.isArray(value.data().genres) ? (
                value.data().genres.map((genre, key) => (
                  <div key={key} className="bg-gray-100 w-fit px-2 rounded-lg mt-2">{genre}</div>
                ))
              ) : (
                <div className="bg-gray-100 w-fit px-2 rounded-lg mt-2">{value.data().genres}</div>
              )
            ) : null}
              </div>
              
                  
                  
                  
              
              
              </div>
           
              
            </>
          )}
        </div>
        
      </div>

      </>
    )
  }

